import { useEffect } from "react";

export default function CreateNewJob() {
  useEffect(() => {
    const container = document.getElementById("calendly-inline-widget");
    if (container) {
      container.innerHTML = "";
      window.Calendly.initInlineWidget({
        url: "https://calendly.com/devmail172/30min",
        parentElement: container,
      });
    }
  }, []);
  return (
    <>
      <section id="create_now_job">
        <div className="container">
          <div className="create-new-job-wrapper">
            <h1>Schedule a meeting to create new job</h1>
            <div className="schedule-call-wrapper">
              <div id="calendly-inline-widget"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
